<template>
  <div>
    <div v-show="not_found" class="container">
      <h2 class="title" style="font-size: 52px;">CPF não cadastrado!</h2>
      <h2 class="title" style="font-size: 52px;">Por favor, teste com número de celular cadastrado.</h2>
    </div>
    <div v-show="!not_found" class="container">
      <h2 class="title">Informe seu CPF</h2>
      <div v-if="error_message" class="error-panel">{{ error_message }}</div>
      <div class="input">
        <input type="text" maxlength="14"
        v-model="cpf"
        v-mask="'###.###.###-##'">
      </div>
      <div class="keyboard">
        <table class="numeric-keyboard">
            <tbody>
                <tr>
                    <td class="numeric-keyboard-key" @click="setCpf('1')">1</td>
                    <td class="numeric-keyboard-key" @click="setCpf('2')">2</td>
                    <td class="numeric-keyboard-key" @click="setCpf('3')">3</td>
                </tr>
                <tr>
                    <td class="numeric-keyboard-key" @click="setCpf('4')">4</td>
                    <td class="numeric-keyboard-key" @click="setCpf('5')">5</td>
                    <td class="numeric-keyboard-key" @click="setCpf('6')">6</td>
                </tr>
                <tr>
                    <td class="numeric-keyboard-key" @click="setCpf('7')">7</td>
                    <td class="numeric-keyboard-key" @click="setCpf('8')">8</td>
                    <td class="numeric-keyboard-key" @click="setCpf('9')">9</td>
                </tr>
                <tr>
                    <td class="numeric-keyboard-key" @click="deleteCpf()">
                      <i class="ui eraser icon" style="color: gray;"></i>
                    </td>
                    <td class="numeric-keyboard-key" @click="setCpf('0')">0</td>
                    <td id="confirm" :class="['numeric-keyboard-key', { inactive: !canConfirm }]"
                    @click="confirmCpf()">
                      <i class="ui check icon" style="color: #2f80ed;"></i>
                    </td>
                </tr>
            </tbody>
        </table>
      </div>
    </div>
    <div class="footer-btn">
      <div id="back-btn" class="btn btn-cancel" @click.prevent="$emit('backClicked', 'StartPage');">
        <i class="ui sign-out icon"></i>
        <span>Cancelar</span>
      </div>
    </div>
  </div>
</template>
<script>
//import { NumericKeyboard } from 'numeric-keyboard/dist/numeric_keyboard.vue'
import { mask } from 'vue-the-mask'
export default {
  /* components: {
    NumericKeyboard
  }, */
  directives: {
    mask
  },
  data() {
    return {
      cpf: '',
      keyPressed: '',
      not_found: false,
      is_loading: false,
      error_message: ''
    }
  },
  computed: {
    cpfDigits() {
      return this.cpf.replace(/\D/g, '');
    },
    canConfirm() {
      return !this.is_loading && this.cpfDigits.length === 11 && this.testaCpf(this.cpfDigits);
    }
  },
  methods: {
    testaCpf(strCPF) {
      var Soma;
      var Resto;
      Soma = 0;

      if (strCPF == "00000000000") return false;

      for (let i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto == 10) || (Resto == 11))  Resto = 0;
      if (Resto != parseInt(strCPF.substring(9, 10)) ) return false;

      Soma = 0;
      for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto == 10) || (Resto == 11))  Resto = 0;
      if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false;
      return true;
    },
    setCpf(key) {
      if (this.is_loading || this.cpfDigits.length >= 11) return;
      this.error_message = '';
      this.cpf = this.cpf + key;
    },
    deleteCpf() {
      //this.cpf = this.cpf.substring(0, (this.cpf.length - 1));
      this.cpf = '';
      this.error_message = '';
    },
    async confirmCpf() {
      if (!this.canConfirm) {
        this.error_message = 'Informe um CPF válido.';
        return;
      }
      this.is_loading = true;
      this.error_message = '';
      try {
        const { data } = await axios.get('api/kiosk/customer/customerschedulingcpf/' + this.cpfDigits);
          if (data.data.length > 0) {
            let customer = data.data;
            if (customer.length > 1) {
              this.$emit('foundCustomer', customer);
              this.$emit('buttonClicked', 'CheckinCustomers')
            } else {
              const response = await axios.get('api/kiosk/customer/customerschedulingid/' + customer[0].id);
              this.$emit('setRequisitions', response.data.data.schedulings);
              this.$emit('buttonClicked', 'FinishCheckin')
            }
          } else {
            var app = this;
            this.not_found = true;
            this.cpf = '';
            setTimeout(function() {
              app.not_found = false;
            }, 6000);
          }
      } catch (err) {
        this.error_message = 'Não foi possível consultar o CPF. Verifique a conexão e tente novamente.';
      } finally {
        this.is_loading = false;
      }
    }
  }
}
</script>
<style scoped>
@media only screen and (min-width: 320px) {
  .input {
    width: 100%;
    height: 46px;
  }
  input {
    margin-left: 22px;
    font-size: 28px;
  }
  .keyboard {
    width: fit-content;
  }
  /* .footer-btn {
    width: 100%;
    margin: 0 auto;
    margin-top: 20px;
    padding: 0px;
    bottom: 42px;
    left: 0px;
  } */
  /* .btn {
    width: 130px;
    margin: 0 auto;
    height: 46px;
    padding: 0 14px;
  }
  .btn-cancel i {
    position: inherit;
    font-size: 20px;
  }
  .btn-cancel span {
    font-size: 20px;
  } */
}

@media only screen and (min-width: 500px) {
  .container {
    position: absolute;
    top: 70%;
    left: 25%;
    width: 100%;
    margin: -24% 0 0 -25%;
  }
  h2 {
    font-size: 42px;
  }
  .input {
    width: 30%;
    height: 80px;
  }
  input {
    margin-left: 30px;
    font-size: 46px;
  }
  .keyboard {
    width: 30%;
  }
  /* .footer-btn {
    position: fixed;
  } */
  /* .btn {
    margin: 0px;
    width: 180px;
    height: 60px;
  }
  .btn-cancel i {
    position: absolute;
    font-size: 26px;
  }
  .btn-cancel span {
    padding-left: 43px;
    font-size: 24px;
  } */
}

h2 {
  color: #fff;
}
.input {
  height: 60px;
  margin: 0 auto;
  padding: 0px 40px;
  background: #fff;
  border-radius: 500px;
  box-shadow: 0px 10px 8px rgba(0, 0, 0, 0.22), 0 1px 2px rgba(0, 0, 0, 0.23);
}
input {
  float: left;
  width: 80%;
  height: -webkit-fill-available;
  text-align: center;
  border: none;
  outline: none;
}
.keyboard {
  //width: 30%;
  height: 300px;
  margin: 0 auto;
  margin-top: 20px;
}
.numeric-keyboard {
  width: 100%;
  height: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 10px;
  font-size: 1.8em;
  text-align: center;
}
.numeric-keyboard-key {
  padding: 10px;
  touch-action: manipulation;
  transition: background 0.5s;
  color: #555;
  background: #fff;
  border-radius: 500px;
  box-shadow: 0px 10px 8px rgba(0, 0, 0, 0.22), 0 1px 2px rgba(0, 0, 0, 0.23);
}
.numeric-keyboard-key.active {
  background: lightblue;
}
.inactive {
  background: #c3c3c3;
}
.inactive i {
  color: #fff!important;
}
</style>



// WEBPACK FOOTER //
// src/components/CheckinCpf.vue